// extracted by mini-css-extract-plugin
module.exports = {"countDetails":"CountDetails_countDetails__3QxjY","countDetailsSubtitle":"CountDetails_countDetailsSubtitle__1R5g3"};